import { Box } from '@usealloy/component-library';
import React from 'react';

interface BaseChangeContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}
export default function BaseChangeContainer({
  children,
  style,
}: BaseChangeContainerProps) {
  return (
    <Box
      justifyContent="flex-start"
      style={{
        maxWidth: '680px',
        borderRadius: 'var(--cl-radius-3)',
        border: '1px solid black',
        padding: 'var(--cl-space-4)',
        marginTop: 'var(--cl-space-2)',
        ...style,
      }}
    >
      {children}
    </Box>
  );
}
